export default __webpack_public_path__ + "static/media/bring-pepe-the-money.371209b0.jpeg";